import { requireAnyOrgPermission, requireAnySystemPermission } from '@juvare/contact-management/backend/features/permissions/shared';
export function hasPermissionsToAccessAccounts(userState) {
    const canManageAllAccounts = requireAnySystemPermission(userState, 'manage-accounts', 'list-all-accounts');
    const canManageSomeAccountsViaOrg = requireAnyOrgPermission(userState, 'manage-members');
    return {
        canManageAllAccounts,
        canManageSomeAccountsViaOrg,
        canManageSomeAccountsViaAnyMeans: canManageAllAccounts || canManageSomeAccountsViaOrg,
    };
}
